// FIXME: #646 refactor this ...
export const getFileNames = (files) => {
  const output = [];
  Object.values(files).forEach((fileArray) => {
    output.push(fileArray[0].name);
  });
  return output;
};



// WEBPACK FOOTER //
// ./services/transcriptManager.js